module.exports = __webpack_public_path__ + "img/banner-mobile.2a7583c9.jpg";